<template>
  <div>
    <h5 class="title is-5 has-text-white module-name">
      <a-icon type="rollback" @click="toHigherLand" v-if="currentLand && currentLand.areaLevel > 1"/>
      <span>{{currentLand ? (currentLand.manorName || currentLand.areaName) + '（' + currentLand.areaLevel + '级）' : ''}}</span>
    </h5>
    <div class="line"></div>
    <!-- <div class="land-add"> -->
    <div class="land-add" v-if="currentLand && currentLand.areaLevel < 4">
      <a class="button is-small is-info" @click="showLandDetailModal()">{{addLandBtnText}}</a>
    </div>
    <div class="line"></div>
    <div class="land-list">
      <div class="land-item" v-for="(item, index) in landList" :key="index" @click="showLandDetailModal(item)">{{item.manorName || item.areaName}}</div>
    </div>
    <LandDetail ref="detail" :visible="detailVisible" :areaLevel="currentLand ? currentLand.areaLevel : 0"
      :hasBtn="currLowerLand ? true : false" @delete="handleLandDelete"
      @cancel="detailVisible = false" @submit="handleLandSubmit" @to-lower="toLowerLand" />
  </div>
</template>

<script>
var self = null
import LandDetail from './components/LandDetail'
export default {
  components: {
    LandDetail
  },
  props: {
    // currentLand: {
    //   type: Object
    // }
  },
  data() {
    return {
      // 当前地块的下级地块，土地列表
      landList: [],
      detailVisible: false,
      // 当前地块
      currentLand: null,
      // 当前选择的下级地块
      currLowerLand: null,
      // 存储历史上级地块
      historyLand: [],
    }
  },
  created() {
    self = this
  },
  mounted() {
    this.getPageManor(true)
  },
  computed: {
    // 添加地块按钮文字
    addLandBtnText() {
      var level = ''
      if(this.currentLand) {
        switch(this.currentLand.areaLevel) {
          case 1: level = '二级'; break;
          case 2: level = '三级'; break;
          case 3: level = '四级'; break;
        }
      } else {
        level = '一级'
      }
      return `添加${level}地块`
    }
  },
  methods: {
    // 增加土地
    showLandDetailModal(item) {
      console.log('item', item)
      this.detailVisible = true
      if(item) {
        this.currLowerLand = item
        this.$nextTick(() => {
          item.areaName = item.manorName || item.areaName
          this.$refs.detail.initForm(item)
        })
      } else {
        this.currLowerLand = null
      }
    },
    // 根据级别获取土地列表
    getLandListByLevel(level, land) {
      console.log('get', level, land)
      if(level == 1) {
        this.getPageManor()
      } else if(level == 2) {
        this.getSecondArea(land)
      } else if(level == 3) {
        this.getThreeArea(land)
      } else if(level == 4) {
        this.getFourArea(land)
      } else {
        this.landList = []
      }
    },
    // 前往上级
    toHigherLand() {
      console.log('history', this.historyLand)
      if(this.historyLand.length > 0) {
        this.currentLand = this.historyLand.pop()
        self.$emit('change-land', this.currentLand)
        this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand)
      }
    },
    // 前往下级
    toLowerLand() {
      console.log('tolower', this.currLowerLand)
      this.detailVisible = false
      if(this.currLowerLand) {
        this.historyLand.push(this.currentLand)
        this.currentLand = this.currLowerLand
        self.$emit('change-land', this.currentLand)
        this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand)
      }
    },
    // 删除土地
    handleLandDelete() {
      this.detailVisible = false
      var actionMethod = ''
      var { areaLevel, id } = this.currLowerLand
      if(areaLevel == 2) {
        actionMethod = this.$api.deleteSecondArea
      } else if(areaLevel == 3) {
        actionMethod = this.$api.deleteThreeArea
      } else if(areaLevel == 4) {
        actionMethod = this.$api.deleteFourArea
      }
      if(actionMethod) {
        var params = [id]
        actionMethod(params).then(res => {
          self.$message.success('删除成功')
          self.getLandListByLevel(self.currentLand.areaLevel, self.currentLand)
        })
      }
    },
    // 新增/修改土地
    handleLandSubmit(value) {
      console.log('submit', value)
      this.detailVisible = false
      
      var actionMethod = ''
      var params = {}
      // 有当前下级地块，为修改
      if(this.currLowerLand) {
        var areaLevel = this.currLowerLand.areaLevel
        
        if(areaLevel === 1) {
          actionMethod = this.$api.updateManor
          params = {
            id: this.currLowerLand.id,
            manorName: value.areaName
          }
        } else if(areaLevel === 2) {
          actionMethod = this.$api.updateSecondArea
          params = {
            id: this.currLowerLand.id,
            ...value
          }
        } else if(areaLevel === 3) {
          actionMethod = this.$api.updateThreeArea
          params = {
            id: this.currLowerLand.id,
            ...value
          }
        } else if(areaLevel === 4) {
          actionMethod = this.$api.updateFourArea
          params = {
            id: this.currLowerLand.id,
            ...value
          }
        }
        if(actionMethod) {
          actionMethod(params).then(res => {
            self.$message.success('修改成功')
            self.getLandListByLevel(self.currLowerLand.areaLevel, self.currentLand)
          })
        }
      } else {
        if(this.currentLand) {
          if(this.currentLand.areaLevel === 1) {
            actionMethod = this.$api.addSecondArea
            params = {
              ...value,
              parentId: this.currentLand.id
            }
          } else if(this.currentLand.areaLevel === 2) {
            actionMethod = this.$api.addThreeArea
            params = {
              ...value,
              parentId: this.currentLand.id
            }
          } else if(this.currentLand.areaLevel === 3) {
            actionMethod = this.$api.addFourArea
            params = {
              ...value,
              parentId: this.currentLand.id
            }
          }
        } else {
          // 没有当前选择地块，为一级地块
          actionMethod = this.$api.addManor
          params = {
            manorName: value.areaName
          }
        }
        if(actionMethod) {
          actionMethod(params).then(res => {
            if(res) {
              self.$message.success('添加地块成功')
              self.getLandListByLevel(self.currentLand ? (self.currentLand.areaLevel + 1) : 1, self.currentLand)
            }
          })
        }
      }
    },
    // 通过vrid跳转到对应土地
    toLandByVrId(vrId) {
      var item = this.landList.find(item => {
        return item.vrId === vrId
      })
      if(item) {
        this.currLowerLand = item
        this.toLowerLand()
      }
    },
    // 下载土地excel
    downloadManor() {
      this.$api.exportManor().then(res => {
        fileDownload(res, '土地.xls')
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 获取土地列表
    getPageManor(firstTime) {
      this.$api.getManor({
        page: 1,
        size: 10
      }).then(res => {
        if(res.content.length > 0) {
          self.currentLand = res.content[0]
          if(firstTime) {
            self.$emit('change-land', self.currentLand)
          }
          self.getLandListByLevel(self.currentLand.areaLevel + 1, self.currentLand)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取二级地块
    getSecondArea(land) {
      // const self = this
      this.$api.getSecondArea({
        page: 1,
        size: 10,
        parentId: land.id
      }).then(res => {
        if(res.content) {
          self.landList = res.content
        }
      })
    },
    // 获取三级地块
    getThreeArea(land) {
      this.$api.getThreeArea({
        page: 1,
        size: 10,
        parentId: land.id
      }).then(res => {
        if(res.content) {
          self.landList = res.content
        }
      })
    },
    // 获取四级地块
    getFourArea(land) {
      this.$api.getFourArea({
        page: 1,
        size: 10,
        parentId: land.id
      }).then(res => {
        if(res.content) {
          self.landList = res.content
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .module-name {
    min-height: 50px;
    line-height: 50px;
    padding-left: 10px;
    margin: 0;
  }
  .land-list {
    .land-item {
      margin: 10px 0;
      padding: 4px 10px;
      background-color: #3a3a3a;
      cursor: pointer;
      min-height: 32px;
      line-height: 32px;
      color: white;
      text-align: center;
      &:hover {
        background-color: #427afb;
      }
    }
  }
  .land-add {
    padding: 10px;

    a {
      width: 100%;
      height: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// Land.vue?41e82176